import React from 'react';
import { Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { format } from 'date-fns';
import { useGuardRoleContext } from '../../context/GuardRoleProvider';

interface InfoComponentProps {
	// Define your props here
}

const InfoComponent: React.FC<InfoComponentProps> = (props) => {
	const { isAdmin, guardSelectorOptions } = useGuardRoleContext();
	const guardName: string = guardSelectorOptions.selectedGuardName;

	let message = '';
	if (isAdmin) {
		if (
			guardSelectorOptions.selectedDate &&
			guardSelectorOptions.selectedGuardName
		) {
			message = `No patrols scheduled for ${guardName} on ${format(
				guardSelectorOptions.selectedDate,
				'EEE, d MMM yyyy',
			)}`;
		} else {
			message = 'Please select a guard and a date to view patrols';
		}
	} else {
		message = 'No patrols scheduled';
	}

	return (
		<div
			style={{
				width: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column',
				padding: '2rem',
			}}
		>
			<ErrorOutlineIcon
				color="warning"
				style={{
					width: '150px',
					height: '150px',
				}}
			/>
			<Typography variant="h6" fontWeight={300}>
				{message}
			</Typography>
		</div>
	);
};

export default InfoComponent;
